import { gql } from '@apollo/client/core';

export type TrustedCaregiverInviteResponse = 'ACCEPT' | 'DECLINE';

export const RESPOND_TO_TRUSTED_CAREGIVER_INVITE = gql`
  mutation RespondToTrustedCaregiverInvite($response: TrustedCaregiverInviteResponse!) {
    respondToTrustedCaregiverInvite(response: $response) {
      status
    }
  }
`;
